import React, { Component } from "react";
import { observer } from "mobx-react";
import MUIDataTable from "mui-datatables";
import { Icon, Spin } from "antd";

import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

import { store } from "Provider/store";
import { withNamespaces } from "react-i18next";
import { buildLogsTableTextLabels } from "localization/logsTableTextLabels";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

export const buildColumns = (t) => [
  {
    name: "timestamp",
    label: t("viewlogs.timestamp"),
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: "log",
    label: t("viewlogs.log"),
    options: {
      filter: false,
      sort: true
    }
  }
];

export const buildOptions = (t) => ({
  filter: true,
  selectableRows: false,
  filterType: "checkbox",
  responsive: "scroll",
  textLabels: buildLogsTableTextLabels(t)
});


@observer
class Table extends Component {
  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MUIDataTable: {
          root: {
            backgroundColor: "#FF000"
          },
          paper: {
            boxShadow: "none"
          }
        },
        MUIDataTableBodyCell: {
          root: {
            // backgroundColor: "#FF0000"
          }
        }
      }
    });

  componentDidMount() {
    store.historyLogs.isFetching = true;
    store.fetchLogs();
  }

  render() {
    const { isFetching, logs } = store.historyLogs;
    const { t } = this.props;
    if (isFetching) {
      return (
        <div className="dashboard-spin">
          <Spin tip={t("viewlogs.progress")} indicator={antIcon} />
        </div>
      );
    }
    return (
      <MuiThemeProvider theme={this.getMuiTheme()}>
        <MUIDataTable
          data={logs}
          columns={buildColumns(t)}
          options={buildOptions(t)}
        />
      </MuiThemeProvider>
    );
  }
}

export default withNamespaces()(Table);
